import { render, staticRenderFns } from "./wangEditLess.vue?vue&type=template&id=24896471&scoped=true"
import script from "./wangEditLess.vue?vue&type=script&lang=js"
export * from "./wangEditLess.vue?vue&type=script&lang=js"
import style0 from "./wangEditLess.vue?vue&type=style&index=0&id=24896471&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24896471",
  null
  
)

export default component.exports